import Vue from "vue";
import Component from "vue-class-component";
import {
  LOGIN_CONSTANTS,
  REGISTER_CONSTANS,
  EMMITER_EVENT,
  GOOGLE_AUTH
} from "../constants/LoginConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import OtpInput from "otp-input-vue2";
import { Inject, Watch } from "vue-property-decorator";
import { UserService } from "@/modules/User/services/UserService";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { DOCUMENT } from "@/modules/Document/constants/DocumentConstants";
import { AuthService } from "../services/AuthService";
import firebase from "firebase/app";
import "firebase/auth";
import { USER_VALIDATORS } from "@/modules/User/constants/UserConstants";
@Component({
  name: "Recover",
  components: {
    OtpInput
  }
})
export default class Recover extends Vue {
  @Inject() userService!: UserService;
  @Inject() authService!: AuthService;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  btnClassPrimary = STYLE_CLASSES.PRIMARY_BTN;
  SITE_KEY = process.env.VUE_APP_SITE_KEY;
  ID_CARD = REGISTER_CONSTANS.LABEL.ID;
  SEND_CODE = LOGIN_CONSTANTS.BUTTON.SEND_CODE;
  FORWARD_CODE = LOGIN_CONSTANTS.BUTTON.FORWARD_CODE;
  LABEL_NEW_PASSWORD = LOGIN_CONSTANTS.LABEL.NEW_PASSWORD;
  LABEL_PASSWORD_CONFIRM = LOGIN_CONSTANTS.LABEL.NEW_VALID_PASSWORD;
  TITLE_NEW_PASSWORD = LOGIN_CONSTANTS.BUTTON.NEW_PASSWORD;
  TITLE_FORGOT_PASSWORD = LOGIN_CONSTANTS.BUTTON.FORGOT_PASSWORD;
  MESSAGE_ID = REGISTER_CONSTANS.MESSAGE.CONFIRM_MESSAGE_ID;
  SMS_SENT = REGISTER_CONSTANS.MESSAGE.SMS_SENT;
  FORWARD_SEND_CODE = REGISTER_CONSTANS.MESSAGE.FORWARD_SEND_CODE;
  BTN_USER_VALIDATE = LOGIN_CONSTANTS.BUTTON.VALIDATE;
  BTN_RESET_PASSWORD = LOGIN_CONSTANTS.BUTTON.RESET_PASSWORD;
  EMPTY_STATE_HEADER = DOCUMENT.EMPTY_STATE.HEADER;
  OPT_NOT_FOUND = LOGIN_CONSTANTS.SNACKBAR.OPT_NOT_FOUND;
  OPT_DOCUMENT_NOT_FOUND = LOGIN_CONSTANTS.SNACKBAR.OPT_DOCUMENT_NOT_FOUND;
  passwordRules = [
    (v: string) => v.length >= 8 || REGISTER_CONSTANS.MESSAGE.MIN_LENGTH
  ];
  MIN_LENGHT_PASSWORD = FORM_VALIDATORS.MIN_LENGTH_PASSWORD;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  rulePassword = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    USER_VALIDATORS.MIN_8,
    USER_VALIDATORS.NO_SPACES,
    USER_VALIDATORS.NO_SECUENCE,
    USER_VALIDATORS.CONTAINS_CAP_LETTER
  ];
  viewOtp = false;
  viewModal = false;
  validationButton = false;
  inputPassword = "";
  inputConfirmPassword = "";
  otpValue = "";
  dialog = false;
  inputDocument = "";
  password = "";
  repeatPass = "";
  isDisabledSendCode = true;
  isViewChangePassword = false;
  isDisabledDocument = false;
  isDocumentValid = false;
  userId = "";
  showPassword = false;
  showRepeatPassword = false;
  numberPhone = "";
  messageError = "";
  progress = false;
  recaptchaToken = "";
  phoneFull = "";
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  confirmationResult: any = "";
  recaptchaVerifier: any = null;
  passwordErrorMsg: string[] = [];
  mounted() {
    this.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "recaptcha-container",
      {
        size: "normal",
        callback: (response: string) => {
          this.onCaptchaVerified(response);
        }
      }
    );
    this.recaptchaVerifier.render();
  }

  cancelNotification() {
    this.viewOtp = false;
    this.cleanInput();
  }
  @Watch("inputDocument")
  async onInputDocumentChange() {
    this.inputDocument.length <= 0
      ? (this.isDisabledSendCode = true)
      : (this.isDisabledSendCode = false);
  }
  @Watch("password")
  async validateUserPassword() {
    this.passwordErrorMsg = [];
    this.rulePassword.forEach(rule => {
      const result: string | boolean = rule(this.password);
      if (typeof result == "string") {
        this.passwordErrorMsg.push(result);
      }
    });
  }
  onCompleteHandler(code: string) {
    this.otpValue = code;
  }
  onCaptchaVerified(token: string) {
    this.recaptchaToken = token;
  }
  async validateDocument() {
    try {
      this.progress = true;
      this.isDisabledSendCode = true;
      const response = await this.authService.sendOtp(this.inputDocument);
      if (response.status !== Http.Ok) {
        Snackbar.popError(this.OPT_DOCUMENT_NOT_FOUND);
        return;
      }
      this.numberPhone = `${response.data.phone}`;
      this.phoneFull = `${response.data.phoneComplete}`;
      this.isDisabledSendCode = true;
      this.isDisabledDocument = true;
      this.isDisabledSendCode = true;
      return true;
    } catch (error) {
      Snackbar.popError(this.OPT_DOCUMENT_NOT_FOUND, error as number);
      return false;
    }
  }
  async sendCode() {
    try {
      if (!this.recaptchaToken) {
        Snackbar.popError(LOGIN_CONSTANTS.SNACKBAR.RECAPCHAT_NOT_COMPLETE);
        return;
      }
      const resp = await this.validateDocument();
      if (!resp) {
        this.progress = false;
        Snackbar.popError(this.OPT_DOCUMENT_NOT_FOUND);
        return;
      }
      const appVerifier = this.recaptchaVerifier;
      const numberPhone = `${this.phoneFull}`;

      await firebase
        .auth()
        .signInWithPhoneNumber(numberPhone, appVerifier)
        .then(confirmationResult => {
          this.confirmationResult = confirmationResult;
          this.progress = false;
          this.isDocumentValid = true;
        });
    } catch (error) {
      this.progress = false;
      this.isDocumentValid = false;
      Snackbar.popError(
        `${LOGIN_CONSTANTS.SNACKBAR.OPT_GOOGLE_NOT_ALLOW} - ${error}`
      );
    }
  }
  async forwardValidateDocument() {
    try {
      this.isDisabledDocument = false;
      this.isDisabledSendCode = false;
      this.isDocumentValid = false;
      await this.sendCode();
      Snackbar.popSuccess(this.FORWARD_SEND_CODE);
    } catch (error) {
      Snackbar.popError(this.OPT_DOCUMENT_NOT_FOUND);
    }
  }
  async validateOtp() {
    try {
      const validConfirmation = await this.confirmationResult
        .confirm(this.otpValue)
        .then((result: { user: { uid: string; passed: boolean } }) => {
          return { uid: result.user.uid, passed: true };
        })
        .catch((error: string) => {
          return error;
        });
      if (validConfirmation.code === GOOGLE_AUTH.CODE_INVALID) {
        Snackbar.popError(this.OPT_NOT_FOUND);
        return;
      }
      const codeUid = `${validConfirmation.passed}`;
      const codeOtp = parseInt(this.otpValue.toString());
      const response = await this.authService.validateOtp(
        this.inputDocument,
        codeOtp,
        codeUid
      );
      if (response.status !== Http.Ok) {
        Snackbar.popError(this.OPT_NOT_FOUND);
        firebase.auth().signOut();
        localStorage.removeItem(LOGIN_CONSTANTS.REMOVE_TOKEN);
        return;
      }
      await firebase.auth().signOut();
      localStorage.removeItem(LOGIN_CONSTANTS.REMOVE_TOKEN);

      this.isDocumentValid = false;
      this.validationButton = true;
      this.isViewChangePassword = true;
      this.userId = response.data.id;
    } catch (error) {
      Snackbar.popError(this.OPT_NOT_FOUND);
    }
  }
  async changePasswordUser() {
    try {
      const response = await this.authService.changePasswordUser(
        this.userId,
        this.password
      );
      if (response.code !== Http.Ok) {
        Snackbar.popError(this.OPT_NOT_FOUND);
        return;
      }
      this.isViewChangePassword = false;
      this.validationButton = false;
      Snackbar.popSuccess(response.data);
      this.cleanInput();
    } catch (error) {
      Snackbar.popError(this.OPT_NOT_FOUND);
    }
  }
  async cleanInput() {
    this.inputDocument = "";
    this.otpValue = "";
    this.isDisabledSendCode = true;
    this.isViewChangePassword = false;
    this.validationButton = false;
    this.isDisabledDocument = false;
    this.isDocumentValid = false;
    this.userId = "";
    this.numberPhone = "";
    firebase.auth().signOut();
    localStorage.removeItem(LOGIN_CONSTANTS.REMOVE_TOKEN);
    this.$emit(EMMITER_EVENT.CLOSE_DIALOG);
  }
  matchPassword() {
    return (
      this.repeatPass === this.password || REGISTER_CONSTANS.MESSAGE.MATCH_PASS
    );
  }
}
